import { render, staticRenderFns } from "./SingleApocalypseWow.vue?vue&type=template&id=0b9aff70"
import script from "./SingleApocalypseWow.vue?vue&type=script&lang=js"
export * from "./SingleApocalypseWow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports